export default __webpack_public_path__ + "0b8d45a7e6917a6ce6cf76b075d1aff9.svg";